import { ArrowDown, ArrowUp } from 'lucide-react';
import { formatNumber } from '@/utils';
import { Icon } from '../Icon';
import * as styles from './index.css';

const getDeltaSign = (deltaValue: number): string | null => {
    if (deltaValue > 0) return '+';
    if (deltaValue === 0) return null;
    return '';
};
const getDeltaString = (deltaValue: number | null): string | null => {
    if (deltaValue === null) return null;
    const sign = getDeltaSign(deltaValue);
    if (sign === null) return null;
    return `${sign}${formatNumber(deltaValue)}`;
};

const getDeltaIcon = (deltaValue: number): typeof ArrowUp | typeof ArrowDown | null => {
    if (deltaValue > 0) return ArrowUp;
    if (deltaValue < 0) return ArrowDown;
    return null;
};

type Variant = keyof typeof styles.variants;

const getDeltaVariant = (deltaValue: number): Variant | null => {
    if (deltaValue > 0) return 'positive';
    if (deltaValue < 0) return 'negative';
    return null;
};

type DeltaPillProps = {
    delta: number;
};

export function DeltaPill({ delta }: DeltaPillProps) {
    const deltaString = getDeltaString(delta);
    const deltaVariant = getDeltaVariant(delta);
    const deltaIcon = getDeltaIcon(delta);

    if (!deltaString || !deltaVariant) return null;

    return (
        <span className={styles.variants[deltaVariant]}>
            {deltaIcon && <Icon icon={deltaIcon} size="sm" />}
            {deltaString}
        </span>
    );
}
